export default ({ $wire, watch, itemId, prevItemId, location }) => ({
    isOpen: false,
    showMap: false,
    openTab: $wire.entangle('openTab'),
    openSideBarTab: 0,
    mapTabs: $wire.entangle('mapTabs').live,
    type: $wire.entangle('type').live,
    prevSeenImagesNumber: 0,

    init() {
        this.$watch('isOpen', value => {
            if (value !== true) {
                this.pauseVideo();
                document.body.style.overflow = 'auto';
                document.body.classList.remove('detail-page-modal-open');
            } else {
                document.body.style.overflow = 'hidden';
                document.body.classList.add('detail-page-modal-open');
            }
        });

        this.$watch('openTab', value => {
            this.$dispatch('detail-page-modal-tab-changed', value);
            this.showMap = this.mapTabs.includes(this.openTab);
        });

        window.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                this.close();
            }
        });
    },

    openLocationTab(value) {
        this.open();
        this.openTab = value;

        this.dataLayerPush('map_interest_detail', {
            item_id: itemId,
            prev_item_id: prevItemId,
            location: location,
            method: value,
        });
    },

    openGalleryTab(dispatch, value, anchor) {
        this.open();
        this.openTab = value;
        dispatch('slide-to-anchor', anchor);

        this.dataLayerPush('map_interest_detail', {
            item_id: itemId,
            prev_item_id: prevItemId,
            location: location,
            method: value,
        });
    },

    open() {
        this.isOpen = true;
        document.body.style.overflow = 'hidden';
    },

    close() {
        if (this.isOpen === false) return;

        this.isOpen = false;
        document.body.style.overflow = 'auto';
        this.sendSeenImagesProgress();
    },

    sendSeenImagesProgress() {
        const galleryWrapper = document.querySelector('.mobile-gallery-wrapper').offsetParent
            ? '.desktop-gallery-wrapper'
            : '.mobile-gallery-wrapper';

        const seenImages = document.querySelectorAll(`${galleryWrapper} .js-track-seen[data-seen="true"]`).length ?? 0;
        const totalImages = document.querySelectorAll(`${galleryWrapper} .js-track-seen`).length ?? 0;

        if (seenImages <= this.prevSeenImagesNumber) return;
        this.prevSeenImagesNumber = seenImages;

        this.dataLayerPush('seenImages', {
            images_percent: Math.round((seenImages * 100) / totalImages),
            item_id: itemId,
        });
    },

    toggleMap(e) {
        let dropdownIcon = e.currentTarget;
        let sideBarContainer = document.querySelector('.' + this.type + '-detail__modal-sidebar-toggle');
        let mapComponent = document.querySelector('.' + this.type + '-detail__modal-map-toggle > div > .active-map');
        let mapContainer = document.querySelector('.' + this.type + '-detail__modal-map-toggle');

        mapComponent.classList.toggle('expand');
        this.$dispatch('map-invalidate-size');
        mapContainer.classList.toggle('expand');
        sideBarContainer.classList.toggle('expand');
        dropdownIcon.classList.toggle('rotate');
    },

    pauseVideo() {
        let videoplayer = document.getElementById('videoplayer');

        if (videoplayer !== null) {
            videoplayer.contentWindow.postMessage(
                JSON.stringify({
                    event: 'command',
                    func: 'pauseVideo',
                }),
                '*',
            );
        }
    },

    setOpenTab(value, link = null) {
        if (!link) {
            this.openTab = value;
            this.dataLayerPush('map_interest_detail', {
                item_id: itemId,
                prev_item_id: prevItemId,
                location: location,
                method: value,
            });
        }

        if (link) {
            window.open(link);
        }
    },

    dataLayerPush(eventName, data) {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: eventName,
                ...data,
            });
        }
    },
});
